import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';
const BEST_TIME_TO_VISIT = 'best-time-visit';
const GENERAL_SERVICES = 'GENSERVICE';
const TRAVELL_ADVISORY = 'travel-advisory';
const TRAVELL_ADVISORY_NEW = 'travel-advisory';
const TRAVEL_ESSENTIALS = 'travel-essentials';
const INFORMATION_SERVICES = 'INFO';
const TRAVEL_INFO = 'travel-info';

@Injectable({
  providedIn: 'root',
})
export class TravelinfoService {
  constructor(private http: HttpClient) {}

  public getTravelInfo(selectedpage: any): Observable<any> {
    return this.http.get(environment.apiBaseURL + '/travelinfo/' + TRAVEL_INFO);
  }
  /**
   * get travel info details of selected page
   * @param selectedpage
   */
  public getTravelInfoDetails(selectedpage: any): Observable<any> {
    return this.http.get(environment.apiBaseURL + '/travelinfo/' + selectedpage);
  }

  getTravelDetails(): Observable<any> {
    let language = localStorage.getItem('language');
    language = language.toLowerCase();
    if (language == 'pt') {
      language = 'pt-br';
    }
    if (language == 'zh') {
      language = 'zh-hans';
    }
    if (language.toLowerCase() !== 'en') {
      return this.http.get(environment.BaseURL.toLowerCase() + '/traveldetails/' + language);
    } else {
      return this.http.get(environment.BaseURL.toLowerCase() + '/traveldetails/');
    }
  }
  public getBestTimeToVisitDetails(): Observable<any> {
    return this.http.get(environment.apiBaseURL + '/travelinfo/' + BEST_TIME_TO_VISIT);
  }
  public getGeneralServiceDetails(): Observable<any> {
    return this.http.get(environment.apiBaseURL + '/listingContents/' + GENERAL_SERVICES);
  }
  public getTravelAdvisoryDetails(): Observable<any> {
    return this.http.get(environment.apiBaseURL + '/travelinfo/' + TRAVELL_ADVISORY);
  }
  public getTravelAdvisoryDetailsNew(): Observable<any> {
    return this.http.get(environment.apiBaseURL + '/traveladvisory/' + TRAVELL_ADVISORY_NEW);
  }
  public getTravelEssentialDetails(): Observable<any> {
    return this.http.get(environment.apiBaseURL + '/travelinfo/' + TRAVEL_ESSENTIALS);
  }
  public getInformationServices(): Observable<any> {
    return this.http.get(environment.apiBaseURL + '/listingContents/' + INFORMATION_SERVICES);
  }
}
